// extracted by mini-css-extract-plugin
export default {"space":"CustomerSubscriptionDetailWrapper_space__1ZKSS"};